import { InputAdornment, TextField } from '@material-ui/core';
import { Search } from '@material-ui/icons';

export default function SearchComponent(props) {
  const { className, ...attr } = props;
  return (
    <TextField
      {...attr}
      variant='standard'
      // size='large'
      className={`bg-white rounded max-w-sm ${className} `}
      fullWidth
      id='searchText'
      InputProps={{
        style: { padding: 7 },
        disableUnderline: true,
        startAdornment: (
          <InputAdornment position='start'>
            <Search className='opacity-30 ml-2' />
          </InputAdornment>
        ),
      }}
    />
  );
}
